import { registerAction } from '../../Action'

const LOAD_STATUS = 'LOAD_STATUS'

export const reducer = (state = {}, action) => {
  const status = action.payload.status

  // set status of completed and upcoming to zero,
  // to avoid endless fudging elsewhere - revert this
  // 'adjustedStatus' if we ever need those figures

  const adjustedStatus = Object.keys(status).reduce((acc, bucket) => {
    if (acc[bucket].completed) {
      acc.unseen -= acc[bucket].completed.unseen
      acc[bucket].unseen -= acc[bucket].completed.unseen
      acc[bucket].completed.unseen = 0
    }
    if (acc[bucket].upcoming) {
      acc.unseen -= acc[bucket].upcoming.unseen
      acc[bucket].unseen -= acc[bucket].upcoming.unseen
      acc[bucket].upcoming.unseen = 0
    }
    return acc
  }, status)

  return {
    ...state,
    status: adjustedStatus,
  }
}

const loadStatus = registerAction(LOAD_STATUS, { reducer })

export default loadStatus
